
<div class="navbar-container">
    <img src="assets/img/ipay-logo-long-blue.png">
</div>
<router-outlet></router-outlet>
